export default __webpack_public_path__ + "static/media/packages.11c67d87.gif";